import { render, staticRenderFns } from "./blsSeepassTable.vue?vue&type=template&id=55a9651f&scoped=true"
import script from "./blsSeepassTable.vue?vue&type=script&lang=js"
export * from "./blsSeepassTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9651f",
  null
  
)

export default component.exports